import { OnInit, OnDestroy, EventEmitter, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ChangeDetectorRef } from '@angular/core';
import { MenuHoverEvent } from './menu-hover-event.model';
import { SessionService } from '../../../core/session/session.service';
import { MenuService } from './menu.service';
import { FeatureToggleService } from '@app/shared/feature-toggle/feature.toggle.service';
import { MenuPermissionService } from '@app/pages/users/shared/services/menu-permissions/menu-permission.service';
var MenuComponent = /** @class */ (function () {
    function MenuComponent(translateService, menuService, menuPermissionService, router, sessionService, cdRef, featureToggleService) {
        if (translateService === void 0) { translateService = null; }
        this.translateService = translateService;
        this.menuService = menuService;
        this.menuPermissionService = menuPermissionService;
        this.router = router;
        this.sessionService = sessionService;
        this.cdRef = cdRef;
        this.featureToggleService = featureToggleService;
        this.menu = [];
        this.menuiService = [];
        this.isShowiServices = false;
        this.hasLoadedMenuiService = false;
        this.isMenuInitialized = false;
        this.isMenuReady = false;
        this.menuRetrieval = new EventEmitter();
    }
    MenuComponent.prototype.ngOnInit = function () {
        this.menu = [];
        this.menuiService = [];
        this.isMenuReady = false;
        this.jwt = this.sessionService.retrieveToken();
    };
    MenuComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        setTimeout(function () {
            if (_this.jwt) {
                _this.menuService.fetchMenu(_this.translateService.currentLang, _this.jwt);
            }
            _this.loadMainMenu();
            _this.tryLoadiServices();
        }, 0);
    };
    MenuComponent.prototype.loadMainMenu = function () {
        var _this = this;
        this.menuSubscription = this.menuService.getMenu().subscribe(function (res) {
            _this.menu = res || [];
            _this.isMenuInitialized = true;
            _this.isMenuReady = true;
            _this.menuRetrieval.emit(_this.menu);
            _this.tryAddiServicesToMenu();
        });
    };
    MenuComponent.prototype.tryLoadiServices = function () {
        var _this = this;
        this.featureToggleService
            .fetchLoggedUserFeature(this.jwt)
            .subscribe(function (response) {
            if (response && response.enabled) {
                _this.isShowiServices = true;
                _this.loadiServicesMenu();
            }
            else {
                _this.isShowiServices = false;
                console.log('iServices está desabilitado ou feature toggle falhou');
            }
        }, function (error) {
            _this.isShowiServices = false;
            console.warn('Erro no feature toggle iServices:', error);
        });
    };
    MenuComponent.prototype.loadiServicesMenu = function () {
        var _this = this;
        if (this.hasLoadedMenuiService) {
            return;
        }
        var businessId = this.extractBusinessIdFromToken(this.jwt);
        var gestor = this.getGestorFromLocalStorage();
        this.menuPermissionService.getMenusiService(businessId, gestor).subscribe(function (response) {
            if (response) {
                _this.processiServicesResponse(response);
                _this.hasLoadedMenuiService = true;
                _this.tryAddiServicesToMenu();
            }
        }, function (error) {
            console.warn('Erro ao carregar iServices: ', error);
            _this.hasLoadedMenuiService = true;
        });
    };
    MenuComponent.prototype.processiServicesResponse = function (response) {
        var iServiceAccess = response;
        var perfilConsultaEventosCorporativos = 'CONSULTA EVENTOS CORPORATIVOS';
        var perfilExecucaoEventosCorporativos = 'EXECUCAO EVENTOS CORPORATIVOS';
        var solucoesCustodia = 'SOLUCOES CUSTODIA';
        var iServiceMenuOption = this.createObjectMenu('iServices', 'FM6_00');
        var eventosCategory = this.createObjectCategory('FM6_04');
        var whatsappCategory = this.createObjectCategory('FM6_07');
        for (var _i = 0, _a = iServiceAccess.perfis; _i < _a.length; _i++) {
            var perfil = _a[_i];
            if (perfil.ativo === true) {
                if (perfil.nome !== perfilConsultaEventosCorporativos &&
                    perfil.nome !== perfilExecucaoEventosCorporativos &&
                    perfil.nome !== solucoesCustodia) {
                    var posicaoCategory = this.createObjectCategory('FM6_02');
                    var existingCategory = iServiceMenuOption.categories.find(function (category) { return category.translationKey === 'FM6_02'; });
                    if (!existingCategory) {
                        posicaoCategory.subMenus.push(this.createObjectSubMenu('FM6_03', '/position-control'));
                        iServiceMenuOption.categories.push(posicaoCategory);
                    }
                }
                else if (perfil.nome === perfilConsultaEventosCorporativos) {
                    eventosCategory.subMenus.push(this.createObjectSubMenu('FM6_05', '/corporate-events'));
                }
                else if (perfil.nome === perfilExecucaoEventosCorporativos) {
                    eventosCategory.subMenus.push(this.createObjectSubMenu('FM6_06', '/corporate-events'));
                }
                else if (perfil.nome === solucoesCustodia) {
                    whatsappCategory.subMenus.push(this.createObjectSubMenu('FM6_08', '/whatsapp-support'));
                }
            }
        }
        if (eventosCategory.subMenus.length > 0) {
            iServiceMenuOption.categories.push(eventosCategory);
        }
        if (whatsappCategory.subMenus.length > 0) {
            iServiceMenuOption.categories.push(whatsappCategory);
        }
        if (iServiceMenuOption.categories.length > 0) {
            this.menuiService.push(iServiceMenuOption);
        }
    };
    MenuComponent.prototype.tryAddiServicesToMenu = function () {
        if (this.isMenuInitialized && this.menu && this.isShowiServices && this.menuiService.length > 0) {
            var hasIServices = this.menu.find(function (menu) { return menu.name === 'iServices'; });
            if (!hasIServices) {
                this.menu = this.menu.concat(this.menuiService);
                this.menuRetrieval.emit(this.menu);
            }
        }
    };
    MenuComponent.prototype.onIsHovered = function (event) {
        this.menuHoverEvent = event;
    };
    MenuComponent.prototype.showMenuOptions = function (index) {
        if (!this.searchBarIsFocused) {
            this.searchBarIsFocused = false;
        }
        this.menuHoverEvent = new MenuHoverEvent(true, true, this.searchBarIsFocused, index);
    };
    MenuComponent.prototype.hideMenuOptions = function (index) {
        if (!this.searchBarIsFocused) {
            this.searchBarIsFocused = false;
        }
        this.menuHoverEvent = new MenuHoverEvent(false, false, this.searchBarIsFocused, index);
    };
    MenuComponent.prototype.goHome = function () {
        this.router.navigateByUrl('/');
    };
    MenuComponent.prototype.onShowAllOptions = function (event, index) {
        this.hideMenuOptions(index);
    };
    MenuComponent.prototype.ngOnDestroy = function () {
        if (this.menuSubscription) {
            this.menuSubscription.unsubscribe();
        }
    };
    MenuComponent.prototype.onClickMenu = function (url, index) {
        this.hideMenuOptions(index);
    };
    MenuComponent.prototype.openFullMenu = function (menu) {
        this.menuService.fullMenu(this.translateService.currentLang, menu.name.toLowerCase());
    };
    Object.defineProperty(MenuComponent.prototype, "categories", {
        get: function () {
            return this.menu || [];
        },
        enumerable: true,
        configurable: true
    });
    MenuComponent.prototype.extractBusinessIdFromToken = function (token) {
        var tokenParts = token.split('.');
        var payload = JSON.parse(atob(tokenParts[1]));
        var businessId = payload.usuario;
        return businessId;
    };
    MenuComponent.prototype.getGestorFromLocalStorage = function () {
        var gestor = localStorage.getItem('authUser');
        return JSON.parse(gestor)['gestor'];
    };
    MenuComponent.prototype.showiServices = function () {
        var _this = this;
        this.featureToggleService
            .fetchLoggedUserFeature(this.jwt)
            .subscribe(function (response) {
            if (response) {
                _this.isShowiServices = response.enabled;
                if (!_this.hasLoadedMenuiService) {
                    _this.loadMenuiService();
                    _this.hasLoadedMenuiService = true;
                }
            }
        });
    };
    MenuComponent.prototype.loadMenuiService = function () {
        var _this = this;
        var businessId = this.extractBusinessIdFromToken(this.jwt);
        var gestor = this.getGestorFromLocalStorage();
        var perfilConsultaEventosCorporativos = 'CONSULTA EVENTOS CORPORATIVOS';
        var perfilExecucaoEventosCorporativos = 'EXECUCAO EVENTOS CORPORATIVOS';
        var solucoesCustodia = 'SOLUCOES CUSTODIA';
        this.menuPermissionService.getMenusiService(businessId, gestor).subscribe(function (response) {
            if (response) {
                var iServiceAccess = response;
                var iServiceMenuOption = _this.createObjectMenu('iServices', 'FM6_00');
                var eventosCategory = _this.createObjectCategory('FM6_04');
                var whatsappCategory = _this.createObjectCategory('FM6_07');
                for (var _i = 0, _a = iServiceAccess.perfis; _i < _a.length; _i++) {
                    var perfil = _a[_i];
                    if (perfil.ativo === true) {
                        if (perfil.nome !== perfilConsultaEventosCorporativos &&
                            perfil.nome !== perfilExecucaoEventosCorporativos &&
                            perfil.nome !== solucoesCustodia) {
                            var posicaoCategory = _this.createObjectCategory('FM6_02');
                            var existingCategory = iServiceMenuOption.categories.find(function (category) { return category.translationKey === 'FM6_02'; });
                            if (!existingCategory) {
                                posicaoCategory.subMenus.push(_this.createObjectSubMenu('FM6_03', '/position-control'));
                                iServiceMenuOption.categories.push(posicaoCategory);
                            }
                        }
                        else if (perfil.nome === perfilConsultaEventosCorporativos) {
                            eventosCategory.subMenus.push(_this.createObjectSubMenu('FM6_05', '/corporate-events'));
                        }
                        else if (perfil.nome === perfilExecucaoEventosCorporativos) {
                            eventosCategory.subMenus.push(_this.createObjectSubMenu('FM6_06', '/corporate-events'));
                        }
                        else if (perfil.nome === solucoesCustodia) {
                            whatsappCategory.subMenus.push(_this.createObjectSubMenu('FM6_08', '/whatsapp-support'));
                        }
                    }
                }
                if (eventosCategory.subMenus.length > 0) {
                    iServiceMenuOption.categories.push(eventosCategory);
                }
                if (whatsappCategory.subMenus.length > 0) {
                    iServiceMenuOption.categories.push(whatsappCategory);
                }
                _this.menuiService.push(iServiceMenuOption);
            }
        });
    };
    MenuComponent.prototype.createObjectMenu = function (name, translationKey) {
        return {
            id: 0,
            name: name,
            description: name,
            translationKey: translationKey,
            categories: []
        };
    };
    MenuComponent.prototype.createObjectCategory = function (translationKeyPrincipalMenu) {
        return {
            translationKey: translationKeyPrincipalMenu,
            subMenus: []
        };
    };
    MenuComponent.prototype.createObjectSubMenu = function (translationKey, url) {
        return {
            translationKey: translationKey,
            tipoMenu: 6,
            url: this.featureToggleService.getiServicesLinks(url)
        };
    };
    return MenuComponent;
}());
export { MenuComponent };
